<template>
  <div class="d-flex align-items-center justify-content-center">
    <transition name="fade-trans" mode="out-in">
      <div v-if="!target" class="options-wrapper" key="options">
        <div class="option" @click="target = 'navbar'">
          <h3>Navbar</h3>
        </div>
        <div class="option main" @click="target = 'main'">
          <h3>Main column</h3>
        </div>
        <div class="option" @click="target = 'footer'">
          <h3>Footer</h3>
        </div>
      </div>
      <div v-else class="p-3 flex-grow-1 align-self-start" key="content">
        <div class="pb-3">
          <span class="link-option" @click="target = null">Contents</span> >
          <span> {{ target[0].toUpperCase() + target.substring(1) }}</span>
        </div>

        <BlocksCrud v-if="target === 'main'"
          :config='config'
          :currentClientWidth='currentClientWidth'
          :fullDomainLink='fullDomainLink'
          position='main'
          
          @set-blocks='blocks => $emit("set-blocks", blocks)'
        />
        <BlocksCrud v-else-if="target === 'navbar'"
          :config='config'
          :currentClientWidth='currentClientWidth'
          :fullDomainLink='fullDomainLink'
          :singleBlock='true'
          position='navbar'

          @set-blocks='blocks => $emit("set-navbar-blocks", blocks)'
        />
        <BlocksCrud v-else-if="target === 'footer'"
          :config='config'
          :currentClientWidth='currentClientWidth'
          :fullDomainLink='fullDomainLink'
          :singleBlock='true'
          position='footer'

          @set-blocks='blocks => $emit("set-footer-blocks", blocks)'
        />
      </div>

    </transition>
  </div>
</template>

<script>

import BlocksCrud from "./BlocksCrud.vue"

export default {
  components: {
    BlocksCrud,
  },
  props: {
    config: Object,
    currentClientWidth: Number,
    fullDomainLink: String,
  },
  data() {
    return {
      target: null,
    }
  },
  watch: {
    target(val) {
      this.$emit("input", val)
    },
  },
}

</script>

<style scoped>

.link-option {
  cursor: pointer;
}

.link-option:hover {
  text-decoration: underline;
}

.options-wrapper {
  flex-basis: 300px;
  margin-left: 6px;
  margin-right: 6px;
}

.options-wrapper > div + div {
  margin-top: 8px;
}

.option {
  border: 1px solid rgb(232,232,232);
  border-radius: 6px;
  padding: 8px;
  background-color: rgb(248,248,248);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition-duration: .15s;
}

.option:hover {
  background-color: rgb(238,238,238);
}

.main {
  height: 150px;
}

h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

</style>
